import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import { HostBridgeService } from "./services/host-bridge/host-bridge.service";
import { UtilsService } from "./services/utils/utils.service";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly utilsService = inject(UtilsService);
  private readonly hostBridge = inject(HostBridgeService);

  public readonly isInIframe: boolean;
  public readonly isTouchScreen: boolean;

  constructor() {
    this.isInIframe = this.utilsService.isInIframe();
    this.isTouchScreen = this.utilsService.isTouchScreen();
    this.hostBridge.start();
  }
}
